export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/organization-activity-setup/:pageId',
        component: () => import('@/views/page/company/procurement/activity/ActivitySetup.vue'),
        name: 'organization-activity-setup',
        meta: {
            requiresAuth: true
        }
    }
]
